import * as React from "react";
import { Action, Dispatch } from "redux";
import { AppState } from "../store/app_state";

import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { TSearchCustomerRequest } from "../../domain/repository/customer_repository";
import { api, entity } from "../../infra/api/rpc/api";
import { createClientTopPageActionCreator } from "../action/client_top_page_action";
import ClientTopPageComponent from "../component/client/top_page/client_top_page";
import {
  IClientTopPageDispatcher,
  createClientTopPageDispatcher,
} from "../dispatcher/client_top_page_dispatcher";
import { GetCustomersByClientTopPageRequest } from "../request/customer_request";
import { ClientTopPageState } from "../store/client_top_page_state";

interface IProps extends RouteComponentProps<{}> {
  state: ClientTopPageState;
  dispatcher: IClientTopPageDispatcher;
}

interface IState {
  isInit: boolean;
}

class ClientTopPageContainer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: false,
    };
  }

  public componentDidMount() {
    const searchCustomerRequest: TSearchCustomerRequest = {
      query: "",
      page: 1,
      offset: 20,
      singleSkillTagIDs: [],
      multiSkillTagIDs: [],
      occupationSkillTagCategory:
        entity.OccupationSkillTag.Category.Category_Unknown,
      occupationSkillTagId: "",
      gender: entity.User.Gender.Gender_Unknown,
      age: api.CustomerAgeSearchType.Unknown,
      workIntention: entity.Customer.WorkIntention.WorkIntention_Unknown,
      fullTimePossibility:
        entity.Customer.FullTimePossibility.FullTimePossibility_Unknown,
    };
    const req: GetCustomersByClientTopPageRequest =
      new GetCustomersByClientTopPageRequest();
    req.searchCustomerRequest = searchCustomerRequest;
    this.props.dispatcher.getCustomers(req);
  }

  public componentDidUpdate(prevProps: IProps) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { isInit } = this.state;
    const { state } = this.props;
    const {
      customers,
      occupationCounts,
      clientBookmarks,
      jobCareersWithCustomerID,
      isLoading,
    } = state;

    return (
      <ClientTopPageComponent
        isInit={isInit}
        isLoading={isLoading}
        customers={customers}
        clientBookmarks={clientBookmarks}
        jobCareersWithCustomerID={jobCareersWithCustomerID}
        occupationCounts={occupationCounts}
        handleSearch={this.handleSearch}
      />
    );
  }

  private handleSearch = (values: any) => {
    const { history } = this.props;

    const query: string = values.q ? values.q : "";
    const category: string = values.category ? values.category : "";

    history.push(`/client/scout/customers?q=${query}&p=1&otc=${category}`);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientTopPageReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientTopPageDispatcher(
      dispatch,
      createClientTopPageActionCreator()
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientTopPageContainer);



// WEBPACK FOOTER //
// ./src/presentation/container/client_top_page_container.tsx